import Grid from '../../view/grid';
import Template from './types.form.template';

import { hashify } from '../../utils/arrays';





export default Template.extend( {

    template: 'module/refbooks/types.form.bound-organizations',

    url() {
        return this.options.type.id
            ? `types/${this.options.type.id}/edit/bound-organizations`
            : `types/new/bound-organizations`;
    },

    open({ type, original, bindings }) {
        const {
            orgsPage = 1, orgsLimit = 10,
            orgsSort = 'name', orgsDirection = 'asc',
            orgsSearch = '',
        } = this.state() || {};

        this.setState( { 
            orgsPage, orgsLimit, orgsSort, orgsDirection, orgsSearch,
        } );

        return Template.prototype.open.call( this, { type, original, bindings } );
    },

    start() {
        Template.prototype.start.call( this );

        this.listenTo( this.options.type, 'change:default_type',
            () => this.OrgGrid.enable( this.model.get( 'default_type' ) === 'f' ) );

        return this;
    },

    serialize() {
        const { orgsSort, orgsDirection, orgsSearch, } = this.state();
        const { filtered, resulted, } = this.options;

        return {
            ...Template.prototype.serialize.call( this ),
            organizations: filtered,
            rows: resulted,
            orgsSearch, orgsSort, orgsDirection,
        };
    },

    events: {

        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;

            return this.setState( { orgsPage: 1, orgsSort: sort, orgsDirection: direction, } ),
                this.reSortGrid().then( () => this.reFilterGrid() )
                    // hack: to rerender grid caption with order direction
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

        'click .-toggle-binding'({currentTarget}) {
            const { id } = currentTarget.dataset;
            const { type, filtered, } = this.options;

            const needAppend = currentTarget.checked;
            const oldOrganizations = type.get( 'departments' );
            const newOrganizations = needAppend
                ? [...oldOrganizations, id]
                : oldOrganizations.filter( itemId => itemId != id );

            type.set( 'departments', newOrganizations );

            const ids = hashify( newOrganizations );
            this.$( '.-toggle-all' )[0].checked = filtered.every( org => ids[org.id] );
        },

        'click .-toggle-all'({currentTarget}) {
            const value = currentTarget.checked;
            const { type, filtered } = this.options;

            const ids = filtered.models.map( item => item.id );
            const h = hashify( ids );
            const drained = type.get( 'departments' )
                .filter( id => !h[id] );

            type.set( 'departments', value
                ? [...drained, ...ids]
                : [...drained] );

            this.$( '.-toggle-binding' ).prop( 'checked', value );
        }

    },

    [Template.event( 'Paging:page')](page) {
        return this.setState( { orgsPage: +page, } ),
            this.reFilterGrid( this ),
            this.navigated();
    },

    [Template.event( 'Search:search')](orgsSearch) {
        return this.setState( { orgsSearch, orgsPage: 1, } ), 
            this.reFilterGrid( this ),
            this.navigated();
    },

    reSortGrid() {
        const clusters = hashify( this.options.clusters, cl => [cl.id, cl] );

        const { orgsSort: column, orgsDirection: direction, } = this.state();
        const sort = column === 'cluster.title'
            ? model => clusters[model.get( 'cluster_id' )].title
            : column;

        return Grid.sort( { sort, direction }, 
            this.options.organizations, this.options.sorted, )
    },

    reFilterGrid() {
        const { orgsPage: page, orgsSearch: search, orgsLimit: limit } = this.state();
        const { type, sorted, filtered, resulted, } = this.options;

        Grid.filter( { page, search, limit },
            type.get( 'cluster' ), 
            sorted, filtered, resulted );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/types.form.bound-organizations.js